"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVariationParams = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _usePdpSearchParams = require("./use-pdp-search-params");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/*
 * This hook will return only the params that are also product attributes for the
 * passed in product object.
 */
const useVariationParams = (product = {}, isProductPartOfSet = false) => {
  const {
    variationAttributes = [],
    variationValues = {}
  } = product;

  // @ts-ignore
  const [allParams, productParams] = (0, _usePdpSearchParams.usePDPSearchParams)(product.id);
  const params = isProductPartOfSet ? productParams : allParams;

  // Using all the variation attribute id from the array generated below, get
  // the value if there is one from the location search params and add it to the
  // accumulator.
  const variationParams = variationAttributes.map(({
    id
  }) => id).reduce((acc, key) => {
    let value = params.get(`${key}`) || (variationValues === null || variationValues === void 0 ? void 0 : variationValues[key]);
    return value ? _objectSpread(_objectSpread({}, acc), {}, {
      [key]: value
    }) : acc;
  }, {});
  return variationParams;
};
exports.useVariationParams = useVariationParams;